// Sposta il bottone "Notify me when available" dell'app Grow: Back In Stock
// (StaqLab/CartBite) dalla posizione floating laterale al posto del bottone
// add-to-cart, dentro #submit-product-button.
//
// Lifecycle dell'app (verificato): il bottone `button.gw-float-widget` viene
// appeso a <body> quando la variante selezionata non è disponibile e rimosso
// quando torna disponibile. Il MutationObserver ricolloca ogni nuova istanza
// e tiene sincronizzata la classe `mm-has-notify` sul container, usata dal
// CSS per nascondere il bottone "Sold out".

(function () {
  const WIDGET_SELECTOR = 'button.gw-float-widget';
  const CONTAINER_ID = 'submit-product-button';

  function sync() {
    const container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    const widget = document.querySelector(WIDGET_SELECTOR);
    if (widget && widget.parentElement !== container) {
      container.appendChild(widget);
    }
    container.classList.toggle('mm-has-notify', !!container.querySelector(WIDGET_SELECTOR));
  }

  function init() {
    sync();
    new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
